'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentCreateRequest(lineage, data) {
  this.a87 = null;
  this.a86 = null;
  this.a87 = lineage;
  this.a86 = data;
}
export { $c_Lapp_data_AppDocumentCreateRequest as $c_Lapp_data_AppDocumentCreateRequest };
$p = $c_Lapp_data_AppDocumentCreateRequest.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentCreateRequest;
/** @constructor */
function $h_Lapp_data_AppDocumentCreateRequest() {
}
export { $h_Lapp_data_AppDocumentCreateRequest as $h_Lapp_data_AppDocumentCreateRequest };
$h_Lapp_data_AppDocumentCreateRequest.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppDocumentCreateRequest)) {
    var x = this.a87;
    var x$2 = x$0.a87;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      var x$3 = this.a86;
      var x$4 = x$0.a86;
      return ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 2;
});
$p.t = (function() {
  return "AppDocumentCreateRequest";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.a87;
  }
  if ((n === 1)) {
    return this.a86;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "lineage";
  }
  if ((n === 1)) {
    return "data";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_data_AppDocumentCreateRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iG)));
}
export { $isArrayOf_Lapp_data_AppDocumentCreateRequest as $isArrayOf_Lapp_data_AppDocumentCreateRequest };
var $d_Lapp_data_AppDocumentCreateRequest = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentCreateRequest, "app.data.AppDocumentCreateRequest", ({
  iG: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_AppDocumentCreateRequest as $d_Lapp_data_AppDocumentCreateRequest };
//# sourceMappingURL=app.data.-App-Document-Create-Request.js.map
